import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { accidentState } from "./atoms/accident";
import { GetMobilityLive } from "./types/types";
import { useQueryClient } from "@tanstack/react-query";
import { deleteNoticeImage } from "./api/notice";
import { useGetMonitoring } from "./hooks/utils/useGetMonitoring";

type Prop = {
  children: React.ReactElement;
};

const WithDetect = ({ children }: Prop) => {
  const queryClient = useQueryClient();

  const [accident, setAccident] = useRecoilState(accidentState);
  const navigate = useNavigate();
  const location = useLocation();

  let muteData = localStorage.getItem("MUTE");

  // 모니터링 데이터
  const { data } = useGetMonitoring();

  // const { data } = useGetDetectLive({
  //   area: user?.area as string,
  //   mobility_code: -1,
  //   searchKey: "",
  //   page: 0,
  //   limit: 100,
  //   isDetect: true,
  // });

  // 농기계 사고관제 데이터
  // const { data: listData } = useGetDetectLive({
  //   area: user?.area as string,
  //   mobility_code: -1,
  //   searchKey: "",
  //   page: 0,
  //   limit: 100,
  // });

  // const { data: webUpdateData } = useGetWebUpdate();

  const forcedFocus = (target: GetMobilityLive) => {
    setAccident(target);
    navigate(`/`/*`/control`*/, {
      state: {
        forced: target,
      },
    });
  };

  // 포커스 이동
  useEffect(() => {
    if (location.pathname !== `/login`) {
      if (
        data &&
        data.list &&
        data.list.filter((el) => el.event_accident !== "정상").length > 0
      ) {
        queryClient.invalidateQueries({ queryKey: ["DetectLive"] });
        // 로컬 스토리지에 muteData 키가 없음 (사고 최초 발생)
        if (!muteData) {
          const target = data.list.filter(
            (el) => el.event_accident !== "정상"
          )[0];

          forcedFocus(target);
        }

        // 로컬 스토리지에 muteData 키가 있음 (사고 연속 발생)
        if (muteData) {
          let muteDataArr = JSON.parse(muteData);
          // 전체 전복사고 이벤트 리스트
          const targets = data.list.filter(
            (el) => el.event_accident !== "정상"
          );
          // 전체 전복 리스트에서 뮤트 데이터에 포함되지 않은 사고 리스트 필터링 (사고는 났지만 뮤트하지 않음)
          let filtered = targets.filter(
            (el) => !muteDataArr.includes(el.accident_header_seq)
          );

          // 뮤트하지 않은 사고 리스트가 1개 이상이면 타겟 지정
          if (filtered.length > 0) {
            const target = filtered[0];
            // setAccident(target);
            forcedFocus(target);
          }

          // 뮤트하지 않은 사고 리스트가 0개면 타겟 비움
          if (filtered.length === 0) {
            setAccident(null);
          }
        }
      }
      // 데이터가 없거나 전복 사고가 없음
      else {
        setAccident(null);
      }
    }
  }, [data, location.pathname, navigate, accident, muteData]);

  // 전복 사고 해제 전에 사용자가 뮤트하면 mutedata 리스트에 추가
  useEffect(() => {
    // let muteData = localStorage.getItem("MUTE");
    if (!muteData) return;
    if (data && data.list) {
      if (
        data.list.filter((el) => el.event_accident !== "정상").length > 0
      ) {
        const targets = data.list.filter(
          (el) => el.event_accident !== "정상"
        ); // 전체 전복사고 이벤트 리스트
        let muteDataArr = JSON.parse(muteData);
        let accidentArr = targets.map((el) => el.accident_header_seq);

        // 뮤트 데이터 배열중에 전복사고 이벤트에 포함되지 않는 것들 삭제 (사고 확인 된 이벤트들)
        let filterdArr = muteDataArr.filter((el: any) =>
          accidentArr.includes(el)
        );

        if (filterdArr.length > 0) {
          localStorage.setItem("MUTE", JSON.stringify(filterdArr));
        } else {
          localStorage.removeItem("MUTE");
        }
      }
      if (
        data.list.filter((el) => el.event_accident !== "정상").length === 0
      ) {
        localStorage.removeItem("MUTE");
      }
    }
  }, [data, accident, muteData]);

  const deleteNoticeImageFn = async (imageName: string) => {
    const res = await deleteNoticeImage({ fileName: imageName });
    if (res.httpStatus === "OK") {
      // console.log("이미지 삭제 성공");
    } else {
      // console.log("삭제 오류", res);
    }
  };

  useEffect(() => {
    // 공지 작성하는 도중 경로를 이탈했는지 확인하기
    // 이유 : 공지 작성중 이미지를 업로드하면 서버에 바로 저장되기 때문에 내용을 저장하지 않고 경로를 이탈하는 경우를 확인하여 이미지 삭제 api를 호출해주어야함
    let localData = localStorage.getItem("noticeImages");
    if (localData && location.pathname !== `/notice-admin`) {
      // 로컬에 저장된 데이터가 있고, 공지 작성중이 아닌 경우
      let imgCounter = localData.match(/userimg/g);
      // console.log(imgCounter);

      if (imgCounter && imgCounter.length > 0) {
        let contents = localData;
        for (let i = 0; i < imgCounter.length; i++) {
          contents.lastIndexOf("/userimg/");
          let deleteName = contents.substring(
            contents.lastIndexOf("/userimg/") + 9
          );
          deleteNoticeImageFn(deleteName);
          contents = contents.substring(
            0,
            contents.lastIndexOf("/userimg/")
          );

          let newData = contents.replace(
            contents.substring(contents.lastIndexOf("/userimg/")),
            ""
          );
          // console.log("반복문 contents", contents);
          if (newData) {
            localStorage.setItem("noticeImages", newData);
          } else {
            localStorage.removeItem("noticeImages");
          }
        }
      }
    }
  }, [location]);

  // 테스트 (브라우저 번역 상태 확인)
  // useEffect(() => {
  //   // console.log(document.documentElement.lang);
  //   document.documentElement.lang = "en";
  // }, []);

  // console.log("muteData", muteData);
  // console.log("accident", accident);

  return children;
};

export default WithDetect;
